import { ALIGN_CLASSES as f, DEFAULT_ALIGNMENT as A, ALIGN_CLASSES_INVERSE as l } from "../../constants.js";
import { defineAttrs as g } from "../../utils/typed-attrs.js";
const u = g({
  alignment: { default: A }
});
function O(r) {
  var a;
  r.attrs = Object.assign({}, r.attrs, u), (a = r.parseDOM) == null || a.forEach(function(n) {
    const e = n.getAttrs;
    n.getAttrs = (s) => {
      let t;
      const o = {};
      return e && Object.assign(o, e(s)), s.classList.forEach((c) => {
        c in l && (t = l[c]);
      }), t && Object.assign(o, { alignment: t }), o;
    };
  });
  const i = r.toDOM;
  return r.toDOM = (n) => {
    const e = n.attrs;
    if (!i)
      throw new Error("must specify a toDOM method");
    const s = i(n);
    if (!Array.isArray(s) || s.length < 2)
      throw new Error("must specify at least two elements in output spec");
    s[1] === 0 && s.splice(1, 0, {});
    const t = s[1];
    return t != null && t.class && typeof t.class == "string" ? t.class += ` ${f[e.alignment]}` : t.class = f[e.alignment], s;
  }, r;
}
export {
  O as centerable,
  u as centerableAttrs
};
